import { render } from "./POICard.vue?vue&type=template&id=1210b25c"
import script from "./POICard.vue?vue&type=script&lang=js"
export * from "./POICard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__